<template>
    <select
        :id="id || name"
        v-model="mutableValue"
        :name="name"
        class="form-control"
        :disabled="isDisabled"
        @change="onChange()"
    >
        <option
            v-if="isNullable"
            :value="nullableValue"
        >
            {{ nullableLabel }}
        </option>

        <option
            v-for="(rowValue, rowKey) in rows"
            :key="rowKey"
            :value="rowKey"
        >
            {{ rowValue }}
        </option>
    </select>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: false,
      default: null,
    },
    endpoint: {
      type: String,
      required: false,
      default: null,
    },
    options: {
      type: Object,
      required: false,
      default: () => {},
    },
    isNullable: {
      type: Boolean,
      default: false,
      required: false,
    },
    nullableValue: {
      type: String,
      required: false,
      default: null,
    },
    nullableLabel: {
      type: String,
      required: false,
      default: null,
    },
    watchVariable: {
      type: [String, Number],
      required: false,
      default: null,
    },
    params: {
      type: Object,
      default: () => {},
      required: false,
    },
    disabled: {
      default: false,
      type: Boolean,
      required: false,
    },
    modelValue: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },

  data() {
    return {
      mutableValue: this.modelValue,
      rows: [],
      isDisabled: this.disabled,
    };
  },

  emits: [
    "update:modelValue",
  ],

  watch: {
    modelValue(newValue) {
      this.mutableValue = newValue;
    },
    disabled(newValue) {
      this.isDisabled = newValue;
    },
    watchVariable() {
      this.getRows();
    },
  },

  mounted() {
    this.getRows();
  },

  methods: {
    onChange() {
      // emit event to update parent data
      this.$emit("update:modelValue", this.mutableValue);
    },
    getRows() {
      // disable while fetching rows
      this.isDisabled = true;

      if (this.options) {
        this.rows = this.options;
        this.isDisabled = (this.disabled ? this.disabled : false);
      } else {
        axios.get(this.endpoint, {
          params: this.params,
        })
          .then((response) => {
            this.rows = response.data;
            this.isDisabled = (this.disabled ? this.disabled : false);
          });
      }
    },
  },
};
</script>
